import { useTheme } from '@mui/material/styles'
import type { ThemeKey } from '@/app/theme/resolveTheme'

// The active theme is resolved per request from the host and stamped onto the MUI theme,
// so reading it from theme context gives the same answer on the server render and on the
// client. Do NOT derive this from window.location in a rendered component: that returns
// the brand fallback during SSR and produces a hydration mismatch.
//
// Client components only. Server components use isHeyaServer() from
// '@/src/utils/server/isHeya'.

export const useThemeKey = (): ThemeKey => useTheme().themeKey

/** True on heya.flyin.com (and its QA twin). Brand stays 'flyin' — see getBrandName(). */
export const useIsHeya = (): boolean => useThemeKey() === 'heya'
